export const COLUMN_KEYS = {
  BOOLEAN: 'boolean',
  FIELD: 'field',
  OPERATOR: 'operator',
  VALUE: 'value',
};
